import toast from "react-hot-toast";
import { instance } from "../BaseUrl/BaseUrl";
import { handleErrors } from "../Utils/util";

const createAction = (type, payloadFunc) => (args) => ({
  type,
  payload: payloadFunc(args),
});

const fetchData =
  (endpoint, successAction) =>
  (
    page,
    limit,
    search,
    setTotalPages,
    setTotalCount,
    ID,
    currentAction,
    startDate,
    endDate,
    type = ''
  ) =>
  async (dispatch) => {
    try {
      let url = `/${endpoint}${ID ? `/${ID}` : ""}`;
      const queryParams = new URLSearchParams();
      page && queryParams.append("page", page);
      limit && queryParams.append("limit", limit);
      search?.combinedFilter &&
        queryParams.append("search", search.combinedFilter);
      currentAction && queryParams.append("action", currentAction);
      startDate && queryParams.append("startDate", startDate);
      endDate && queryParams.append("endDate", endDate);
      type && queryParams.append("type", type);

      // Append the query parameters to the URL
      if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
      }

      const dataResult = await instance.get(url);
      const result = dataResult.data;
      if (dataResult.status === 200) {
        const { data, message, status, meta } = result;
        if (status) {
          if (setTotalCount) setTotalCount(meta?.total);
          if (setTotalPages && limit) setTotalPages(Math.ceil(meta?.total / limit));
          dispatch(successAction(data));
        } else {
          toast.error(message);
        }
      }
    } catch (err) {
      console.log(err);
      handleErrors(err);
    }
  };

// Reusable function to fetch data for an endpoint fetchDataNoPag
const fetchDataNoPag = (endpoint, successAction) => (params = {}) =>  async (dispatch) =>{
  try {
    const queryParams = new URLSearchParams(params).toString();
    const dataResult = await instance.get(`/${endpoint}?${queryParams}`);
    const result = dataResult.data;
    if (dataResult.status === 200) {
      const { data, message, status } = result;
      if (status) {
        dispatch(successAction(data));
        return data;
      } else {
        toast.error(message);
      }
    }
  } catch (err) {
    handleErrors(err);
  }
};

// Reusable function to fetch data for an endpoint Delete Item
const deleteItem =
  (endpoint, successAction, undo = false) =>
  (id, settogglemenu, togglemenu) =>
  async (dispatch) => {
    const method = undo ? "put" : "delete";
    const url = undo
      ? `/${endpoint}/undo-delete/${id}`
      : `/${endpoint}/delete/${id}`;
    try {
      const dataResult = await instance[method](url);
      const result = dataResult.data;
      if (dataResult.status === 200) {
        const { message } = result;
        dispatch(successAction(id));
        toast.success(message);
        if (!undo) {
          settogglemenu(!togglemenu);
        }
      }
    } catch (err) {
      handleErrors(err);
    }
  };

// Reusable function to fetch data for an endpoint Delete Item
const deleteMultipleItem =
  (endpoint, successAction) => (itemIds) => async (dispatch) => {
    try {
      const dataResult = await instance.put(`/${endpoint}/multipleDelete`, {
        itemIds,
      });
      const result = dataResult.data;
      if (dataResult.status === 200) {
        const { message } = result;
        dispatch(successAction(itemIds));
        toast.success(message);
      }
    } catch (err) {
      handleErrors(err);
    }
  };

// Reusable function to fetch data for an endpoint Get Single Data
const getOneItem = (endpoint, successAction) => (id) => async (dispatch) => {
  try {
    const dataResult = await instance.get(`/${endpoint}/fetchOne/${id}`);
    const result = dataResult.data;
    if (dataResult.status === 200) {
      const { data } = result;
      dispatch(successAction(data));
    }
  } catch (err) {
    handleErrors(err);
  }
};

// Reusable function to fetch data for an endpoint Get Single Data
const updateStatus =
  (endpoint, successAction) =>
  (_id, formData, settogglemenu, togglemenu) =>
  async (dispatch) => {
    try {
      const dataResult = await instance.put(`/${endpoint}/update/${_id}`, {
        formData,
      });
      const { data, message } = dataResult.data;
      if (dataResult.status === 200) {
        toast.success(message);
        dispatch(successAction(_id, data));
        settogglemenu(!togglemenu);
      }
    } catch (err) {
      handleErrors(err);
    }
  };

export {
  getOneItem,
  deleteItem,
  fetchData,
  fetchDataNoPag,
  createAction,
  deleteMultipleItem,
  updateStatus,
};
